module.exports = __webpack_public_path__ + "img/KSC08451.26fd805a.jpg";